import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { setupComponents } from "./plugins/setup-components";
import VueChartkick from "vue-chartkick";
import Chart from "chart.js";

export const bus = new Vue() 
Vue.config.productionTip = false
Vue.use(VueChartkick, { adapter: Chart });

setupComponents(Vue);
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
